
import { Store }      from './bin/general/store.js';

import BodyClasses    from "./bin/general/BodyClasses.js";
import ScrollbarWidth from "./bin/general/ScrollbarWidth.js";
import VhUnit         from "./bin/general/VhUnit.js";

import PostContainerWidth from "./bin/general/PostContainerWidth.js";
import WpBlockGroup       from "./bin/general/WpBlockGroup.js";
import WhoScroll          from "./bin/general/WhoScroll.js";
import LocationChange     from "./bin/general/LocationChange.js";

import stickyMainNavigation from "./bin/general/stickyMainNavigation";

import LanguagesDropdown    from "./bin/general/LanguagesDropdown.js";
import HeaderNavigation     from "./bin/general/HeaderNavigation.js";

import FormInputLabel    from "./bin/general/FormInputLabel.js";
import WhoBlockAccordion from "./bin/general/WhoBlockAccordion.js";

import SearchBlogFilter             from "./bin/blog/SearchBlogFilter.js";
import SearchFormPosts              from "./bin/blog/SearchFormPosts.js";
import BlogResultsWatch             from "./bin/blog/BlogResultsWatch.js";
import BlogLoadMoreAjaxButtonLoader from "./bin/blog/BlogLoadMoreAjaxButtonLoader.js";


import SearchJobsCard           from "./bin/jobs/SearchJobsCard.js";
import OffersAutocomplete       from "./bin/jobs/OffersAutocomplete.js";
import OffersResultsWatch       from "./bin/jobs/OffersResultsWatch.js";
import SearchJobsFilter         from "./bin/jobs/SearchJobsFilter.js";
import SearchFormOffers         from "./bin/jobs/SearchFormOffers.js";
import LoadMoreAjaxButtonLoader from "./bin/jobs/LoadMoreAjaxButtonLoader.js";

import ApplicationFormValidation from "./bin/general/ApplicationFormValidation.js";

import WhoSplideJS      from "./bin/general/WhoSplideJS.js";
import WhoSplideAgencySectors from "./bin/general/WhoSplideAgencySectors.js";

import { leaflet_map                       } from "./bin/general/leaflet-map";
import { wp_block_contact_media_text       } from "./bin/general/wp-block-contact-media-text";





(function ($) {

    "use strict";

    $( document ).ready(function(){

        let $body = jQuery('body') ;

        // general
        Store();

        // pimp
        new BodyClasses();
        new ScrollbarWidth();
        new VhUnit();
        new PostContainerWidth();
        new WpBlockGroup();
        new WhoScroll();
        new LocationChange();

        new stickyMainNavigation();

        // layout
        new LanguagesDropdown();
        new HeaderNavigation();

        new FormInputLabel();

        if( $body.hasClass('has--accordion') ){
            new WhoBlockAccordion();
        }


        // blog
        if( $body.hasClass('has--ajax-posts-search') ){

            new SearchBlogFilter();
            new SearchFormPosts();
            new BlogResultsWatch();
            new BlogLoadMoreAjaxButtonLoader();
        }


        // Jobs
        // ? is_bullhorn_active
        
        if( '1' === DATA.is_bullhorn_active ){

            new SearchJobsCard();

            if( $body.hasClass('has--ajax-offers-search') ){

                new OffersAutocomplete();
                new OffersResultsWatch();

                new SearchFormOffers();
                new SearchJobsFilter();
                new LoadMoreAjaxButtonLoader();
            }
        }

        // Application
        new ApplicationFormValidation();

        // offer
        // wp_block_contact_media_text();

        // map
        leaflet_map();


        // slider
        if( $body.hasClass( 'has--splide-js' ) ){

            new WhoSplideJS();
            new WhoSplideAgencySectors();
        }

        // — —


    });

})(jQuery);